import { defineComponent as _defineComponent } from 'vue'
interface Props {
  width?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoreItems.ts',
  props: {
    width: { default: 30 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})